import { render, staticRenderFns } from "./DeviceReferenceEditDialog.vue?vue&type=template&id=f9b5d962&scoped=true"
import script from "./DeviceReferenceEditDialog.vue?vue&type=script&lang=ts"
export * from "./DeviceReferenceEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b5d962",
  null
  
)

export default component.exports